import {GameJuggler, IAnimatable} from "./GameJuggler";
import {GamePool, IPoolable} from "./GamePool";
import {Container} from "pixi.js/lib/scene/container/Container";
import {GameView} from "./GameView";
import * as PIXI from 'pixi.js';

export interface IDestroy {
  destroy(): void;
  get destroyed(): boolean;
}

const isIDestroy = (obj: any) => {
  return obj &&
    typeof obj.destroy === 'function' &&
    typeof obj.destroyed === 'boolean';
}

export class GameObject implements IDestroy, IPoolable, IAnimatable {

  protected _isDestroyed = false;

  protected _juggler: GameJuggler | null = null;

  public advanceTime(delta: number) {
  }

  addToJuggler(): void {
    this.juggler?.addAnimatable(this);
  }

  onRemovedFromJuggler() {

  }

  removeFromJuggler() {
    this.juggler?.removeAnimatable(this);
  }

  public get juggler(): GameJuggler | null {
    return this._juggler;
  }

  public set juggler(value: GameJuggler) {
    this._juggler = value;
  }

  public get destroyed(): boolean {
    return this._isDestroyed;
  }

  static destroy(object: any) {
    if (!object) {
      return null;
    }

    // first check on interfaces

    if (object instanceof GameObject || object instanceof GameView) {
      (object as IDestroy).destroy();
      return null;
    }

    if (isIDestroy(object)) {
      (object as IDestroy).destroy();
      return null;
    }

    // second check on implementations

    if (Array.isArray(object)) {
      const objects = object as Object[] | null; // Проверяем, является ли объект массивом
      if (objects) {
        while (objects.length) {
          this.destroy(objects.pop()!); // Вызываем dispose для каждого элемента
        }
      }
      return null;
    }

    if (object instanceof PIXI.Container) {
      let container = object as Container;
      container.removeFromParent();
      container.destroy({children: true});
    }

    return null;
  }

  public onReturnToPool(): void {
  }

  public onGetFromPool(pool: GamePool): void {
  }

  public destroy(): void {
    if (!this._isDestroyed) {
      this._isDestroyed = true;
      this.removeFromJuggler();
    }
  }

}
